'use strict';

import 'fancybox';

export default function fancybox() {
    let $fancyboxObj = $('.js-fancybox');

    if (!$fancyboxObj.length) {
        return;
    }

    $fancyboxObj.fancybox({
        padding : 0,
        tpl: {
            closeBtn: '<span class="fancybox-close glyphicon glyphicon-remove"></span>',
            next: '<span class="fancybox-next glyphicon glyphicon-menu-right"></span>',
            prev: '<span class="fancybox-prev glyphicon glyphicon-menu-left"></span>'
        }
    });
}
